// extracted by mini-css-extract-plugin
export default {"page":"settings_page__VFOlO"};